var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"noteFound"}},[_c('img',{attrs:{"src":require('@/assets/imgs/Notioly1.png'),"alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noteFound"},[_c('b',[_vm._v("404")]),_c('p',[_vm._v("很抱歉")]),_c('p',[_vm._v("页面找不到了")])])
}]

export { render, staticRenderFns }